import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { MarketItemCategory } from '@common/contracts';
import ImageDropzone from '../ImageDropzone/ImageDropzone';
import { FaChevronDown } from 'react-icons/fa';
import { getMarketCategoryDisplayName } from '../../utils/marketCategoryDisplay';
const AVAILABLE_CATEGORIES = [
    MarketItemCategory.Avatars,
    MarketItemCategory.Boosters,
    MarketItemCategory.AutoClaim,
    MarketItemCategory.BarrackSlots,
    MarketItemCategory.Knowledge,
    MarketItemCategory.Coins,
    MarketItemCategory.CrashEggs
];
export function MarketItemModalForm({ isOpen, onClose, onSubmit, isLoading, mode, item, title, submitIdleLabel, submitBusyLabel }) {
    const [name, setName] = useState('');
    const [category, setCategory] = useState('');
    const [image, setImage] = useState(null);
    const [nameError, setNameError] = useState('');
    const [categoryError, setCategoryError] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    // Reset (create) or populate (edit) the form state every time the modal opens
    useEffect(() => {
        if (!isOpen)
            return;
        if (mode === 'edit') {
            if (!item)
                return;
            setName(item.name);
            setCategory(item.category);
            setImage(item.image);
        }
        else {
            setName('');
            setCategory('');
            setImage(null);
        }
        setNameError('');
        setCategoryError('');
        setIsDropdownOpen(false);
    }, [isOpen, item, mode]);
    const handleSubmit = (e) => {
        e.preventDefault();
        let hasErrors = false;
        if (!name.trim()) {
            setNameError('Name is required');
            hasErrors = true;
        }
        if (!category) {
            setCategoryError('Category is required');
            hasErrors = true;
        }
        if (hasErrors)
            return;
        onSubmit({ name: name.trim(), category: category, image });
    };
    const toggleDropdown = () => {
        if (!isLoading)
            setIsDropdownOpen(prev => !prev);
    };
    useEffect(() => {
        const handler = (ev) => {
            if (dropdownRef.current && !dropdownRef.current.contains(ev.target)) {
                setIsDropdownOpen(false);
            }
        };
        if (isDropdownOpen)
            document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [isDropdownOpen]);
    if (!isOpen || (mode === 'edit' && !item))
        return null;
    const handleClose = () => {
        onClose();
    };
    return (_jsx("div", { className: "modal-overlay", onClick: handleClose, children: _jsxs("div", { className: "modal-content", onClick: e => e.stopPropagation(), children: [_jsxs("div", { className: "modal-header", children: [_jsx("h2", { children: title }), _jsx("button", { className: "close-button", onClick: handleClose, disabled: isLoading, children: "\u00D7" })] }), _jsxs("form", { onSubmit: handleSubmit, className: "modal-form", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { children: "Name" }), _jsx("input", { type: "text", value: name, onChange: e => {
                                        setName(e.target.value);
                                        if (nameError && e.target.value.trim())
                                            setNameError('');
                                    }, disabled: isLoading, className: nameError ? 'error' : '' }), nameError && _jsx("span", { className: "error-text", children: nameError })] }), _jsxs("div", { className: "form-group", ref: dropdownRef, children: [_jsx("label", { children: "Category" }), _jsxs("div", { className: `technology-select ${isDropdownOpen ? 'open' : ''} ${categoryError ? 'error' : ''}`, onClick: toggleDropdown, children: [_jsxs("div", { className: "technology-select-display", children: [_jsx("span", { className: category ? 'selected' : 'placeholder', children: category ? getMarketCategoryDisplayName(category) : 'Select category...' }), _jsx(FaChevronDown, { className: "dropdown-arrow" })] }), isDropdownOpen && (_jsx("ul", { className: "technology-select-options", children: AVAILABLE_CATEGORIES.map(cat => (_jsx("li", { className: `technology-option ${cat === category ? 'selected' : ''}`, onClick: () => {
                                                    setCategory(cat);
                                                    setIsDropdownOpen(false);
                                                    if (categoryError)
                                                        setCategoryError('');
                                                }, children: getMarketCategoryDisplayName(cat) }, cat))) }))] }), categoryError && _jsx("span", { className: "error-text", children: categoryError })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { children: "Image" }), _jsx(ImageDropzone, { currentImageUrl: image, onUploadSuccess: setImage })] }), _jsxs("div", { className: "modal-actions", children: [_jsx("button", { type: "button", onClick: handleClose, disabled: isLoading, children: "Cancel" }), _jsx("button", { type: "submit", disabled: isLoading || !name.trim() || !category, children: isLoading ? submitBusyLabel : submitIdleLabel })] })] })] }) }));
}
